'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactSwitch = require('react-switch');var _reactSwitch2 = _interopRequireDefault(_reactSwitch);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMSwitch = require('./OMSwitch.scss');var styles = _interopRequireWildcard(_OMSwitch);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMSwitch = function OMSwitch(props) {var _cx;return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.switchContainer, (_cx = {}, _cx[styles.column] = props.isColumn, _cx)) },
      _react2.default.createElement('label', { htmlFor: props.id, className: styles.switchLabel },
        _react2.default.createElement('span', { className: styles.switchText }, props.label),
        _react2.default.createElement('span', { className: styles.switchButton },
          _react2.default.createElement(_reactSwitch2.default, {
            onChange: props.onChange,
            checked: props.isChecked,
            className: 'react-switch',
            id: props.id,
            onColor: props.activeColor,
            handleDiameter: props.handleDiameter,
            uncheckedIcon: false,
            checkedIcon: false,
            activeBoxShadow: props.activeBoxShadow,
            boxShadow: props.boxShadow,
            height: props.height,
            width: props.width })))));};






OMSwitch.propTypes = {
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  activeColor: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  isChecked: _propTypes2.default.bool,
  isColumn: _propTypes2.default.bool,
  activeBoxShadow: _propTypes2.default.string,
  boxShadow: _propTypes2.default.string,
  handleDiameter: _propTypes2.default.number,
  height: _propTypes2.default.number,
  width: _propTypes2.default.number };


OMSwitch.defaultProps = {
  activeColor: '#1ad741',
  activeBoxShadow: '#ffffff',
  boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.16)',
  handleDiameter: 22,
  height: 20,
  width: 35 };exports.default =


OMSwitch;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMSwitch/OMSwitch.js
// module id = 2763
// module chunks = 0